var _excluded = ["isHidden"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { Suspense } from 'react';
import { getContentTypeConfig } from './config';

/**
 * Render a content type
 *
 * @param Component
 * @param data
 * @returns {*}
 */
var renderContentType = (Component, data) => {
  return /*#__PURE__*/React.createElement(Component, data, data.children.map((childTreeItem, i) => /*#__PURE__*/React.createElement(ContentTypeFactory, {
    key: i,
    data: childTreeItem
  })));
};

/**
 * Create an instance of a content type component based on configuration
 *
 * @param data
 * @returns {*}
 * @constructor
 */
var ContentTypeFactory = _ref => {
  var {
    data,
    htmlJson
  } = _ref;
  var {
      isHidden
    } = data,
    props = _objectWithoutProperties(data, _excluded);
  if (isHidden) {
    return null;
  }
  var contentTypeConfig = getContentTypeConfig(props.contentType);
  if (contentTypeConfig && contentTypeConfig.component) {
    return /*#__PURE__*/React.createElement(Suspense, {
      fallback: null
    }, renderContentType(contentTypeConfig.component, props));
  }
  return null;
};
export default ContentTypeFactory;